import { IonButton, useIonRouter } from '@ionic/react'

import { useBroadcastActions } from '../../../marketing/broadcasts/broadcast-store'
import { useAccount, useUser } from '../../../contexts/authContext'
import { useShowBroadcast } from '../../../hooks/broadcast/use-show-broadcast'
import { useInitSequence } from '../../../hooks/use-init-sequence'
import type { Client } from '../../../hooks/clients/queries'
import type { Template } from '../../../hooks/templates/queries'

type BulkMessageButtonProps = {
  clientList: Array<Client>
  template?: Template | null
  pointers?: {
    callListId?: string
    callListDynamicId?: string
  }
}

function BulkMessageButton({
  clientList,
  template,
  pointers = {},
}: BulkMessageButtonProps) {
  const user = useUser()
  const account = useAccount()

  const { hasBroadcastSettings } = useShowBroadcast()

  const router = useIonRouter()
  const { initializeSequence } = useInitSequence()
  const { initializeBroadcast } = useBroadcastActions()

  return (
    <>
      {!user.hasTwilio ||
      (user.hasTwilio && user.smsManual) ||
      (user.hasTwilio && !account.optinRequired) ? (
        <IonButton
          disabled={clientList.length === 0}
          size="small"
          color="yellow"
          fill="solid"
          onClick={() => {
            initializeSequence({
              list: clientList,
              backRef: '/tabs/clients',
              template,
              ...pointers,
            })
          }}
        >
          Start Sequence
        </IonButton>
      ) : null}
      {hasBroadcastSettings() ? (
        <IonButton
          disabled={clientList.length === 0}
          size="small"
          color="yellow"
          fill="solid"
          onClick={() => {
            initializeBroadcast({
              clients: clientList,
              account,
              user,
              type: 'associate',
              template,
              ...pointers,
            })
            router.push('/broadcasts/create')
          }}
        >
          Start Broadcast
        </IonButton>
      ) : null}
    </>
  )
}

export default BulkMessageButton
